export default __webpack_public_path__ + "static/auk-logo-de134dfa4b105e2a449bf48cfeab029e.svg";